import { FC, useEffect } from 'react';
import { LandscapeIndicatorContributionTemplate } from '../../templates';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../store/store';
import { useNavigate, useParams } from 'react-router-dom';
import { fetchLandscapeIndicatorDetailsById } from '../../../store/landscapeAPI/landscape/reducers/landscape-indicator.slice';
import Spinner from '../../atoms/Spinner/Spinner';
import { deleteContribution } from '../../../store/landscapeAPI/value/reducers/contribution.slice';

const LandscapeIndicatorContributionPage: FC = () => {
  const dispatch = useDispatch<AppDispatch>();

  const { id, landscapeIndicatorId } = useParams();

  const { landscapeIndicatorDetails, status } = useSelector(
    (state: RootState) => state.landscapeIndicatorSlice
  );

  const navigate = useNavigate();

  useEffect(() => {
    if (!landscapeIndicatorId) {
      return;
    }

    dispatch(fetchLandscapeIndicatorDetailsById(landscapeIndicatorId));
  }, [landscapeIndicatorId, dispatch]);

  const handleDelete = async (id: string) => {
    await dispatch(deleteContribution(id)).unwrap();
    dispatch(fetchLandscapeIndicatorDetailsById(landscapeIndicatorId!));
  };

  const handleUpdate = (contributionId: string) => {
    navigate(
      `/landscapes/edit/${id}/indicators/edit/${landscapeIndicatorId}/contribution/edit/${contributionId}`
    );
  };

  if (status === 'loading') {
    return <Spinner />;
  }

  return (
    <LandscapeIndicatorContributionTemplate
      data={landscapeIndicatorDetails?.contribution ?? []}
      handleDelete={handleDelete}
      handleUpdate={handleUpdate}
    />
  );
};

export default LandscapeIndicatorContributionPage;
